
'use strict';

var $ = require('jquery'),
  config = require('../config'),
  utilities = require('../utilities'),
  applicationTemplate = require('../../tmpl/client/applications/application-items.hbs'),
  Backbone = require('backbone');

Backbone.$ = $;

var ApplicationView = Backbone.View.extend({

  template: applicationTemplate,

  events: {
    'click .js-ref-item-block': 'toggle'
  },

  initialize: function() {
    if (!this.$el.length) return false;
  },

  toggle: function(e) {
    e.preventDefault();
    this.$currentTarget = this.$('.js-ref-item.' + config.classes.isVisible);
    this.$currentTargetDrawer = this.$currentTarget.find('.js-ref-drawer');
    this.$itemTarget = $(e.currentTarget).parent('.js-ref-item');
    this.$drawerTarget = this.$itemTarget.find('.js-ref-drawer');

    if (this.$itemTarget.hasClass(config.classes.isVisible)) {
      this.hide();
    } else {
      this.hide();
      this.show();
    }
  },

  show: function() {
    var that = this;

    if (this.$currentTarget.length) {
      this.$currentTargetDrawer.one(utilities.getTransitionEndName(), function() {
        that.$itemTarget.addClass(config.classes.isVisible);
        $('.RefDrawerTabs-results-item-block').attr('aria-expanded','true');
      });
    } else {
      this.$itemTarget.addClass(config.classes.isVisible);
      $('.RefDrawerTabs-results-item-block').attr('aria-expanded','true');
    }
  },

  hide: function() {
    this.$currentTarget.removeClass(config.classes.isVisible);
    $('.RefDrawerTabs-results-item-block').attr('aria-expanded','false');
  }
});

module.exports = ApplicationView;



// WEBPACK FOOTER //
// ./assets/js/reference/ApplicationTabsView.js